export const seccionesMX = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesCAYC = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesHK = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesFL = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesSGP = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesTR_1 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesTR_2 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

export const seccionesTR_3 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 0,
    "estatus" : false
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  },{
    "nombre" : "Forall",
    "orden" : 6,
    "visible": 1,
    "estatus": false
  },{
    "nombre" : "Adicionales",
    "orden" : 7,
    "visible": 1,
    "estatus" : false
  }
];

/////// SECCIONES MEDIR NUEVOS

export const seccionesMedir_1 = [
  {
    "nombre": "NPS",
    "orden" : 1,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Reactivos",
    "orden": 2,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Control",
    "orden" : 3,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Demograficos",
    "orden" : 4,
    "visible": 1,
    "estatus" : true
  },{
    "nombre" : "Abiertas",
    "orden" : 5,
    "visible": 1,
    "estatus": true
  }
];
